import 'rxjs/add/operator/debounceTime';
import {Component} from '@angular/core';
import {Keyboard, NavController, NavParams, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";
import {TAcessoFind, TAction, TPaybookFlag, TPaybookTipo, TProdutoSale} from "../../../app/enum";
import {LogadoService} from "../../../providers/logado-service";
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'page-consumo-sale',
    templateUrl: 'consumo-sale.html',
    providers: []
})
export class ConsumoSalePage {
    
    TPaybookTipo: any = TPaybookTipo;

    config: any;
    etapa: number;
    hotspotID: number;

    akkjson = (window as any).handappMainInstance.appjson;
    monitorAuth = this.akkjson.hotwork;

    //Etapa - 3
    rootComanda: any;


    //Etapa - 6
    monitorBool: boolean;
    itemProduto: any;
    itemEscolha: string;
    itemConsumo: any;
    meioConsumo: boolean = false;
    qtdeConsumo: Array <any> = [];
    textdata: any;
    comandaIN: number = 0;

    //Etapa - 6
    comandaHalf: boolean;
    produtoWait: boolean;

    //Etapa - 7
    aditionFull: boolean;

    constructor(public viewCtrl: ViewController, public navCtrl: NavController, public navParams: NavParams,
                public logadoService: LogadoService, 
                public deviceService: DeviceDetectorService,
                public util: Util,
                public keyboard: Keyboard) {

        this.config = CONFIG;
        this.etapa = this.util.anyParams(0, this.navParams.get('etapa'));

        //
        this.hotspotID = this.util.anyParams(0, this.navParams.get('hotspotID'));

        this.monitorBool = this.navParams.get('monitorBool');
        this.rootComanda = this.navParams.get('rootComanda');
        this.itemProduto = this.navParams.get('itemProduto');
        this.itemEscolha = this.navParams.get('itemEscolha');
        this.itemConsumo = this.navParams.get('itemConsumo');

        this.comandaIN = this.util.anyParams(0, this.navParams.get('comandaIN'));


        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Consumo - Sale', '/webstor/consumo-sale');

        if (this.etapa == 6) this.consumoQtde(true, true);
        if (this.etapa == 7) this.escolhaInit(null, null);
        if (this.etapa == 7) this.aditionInit();
        if (this.etapa == 7) this.aditionFull = false;

        //Hide Support Button Fab
        (window as any).handappMainInstance.supportShow = false;

    }

    ionViewDidLoad() {

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    getTitle() {

        let comanda = this.rootComanda.Comandas[this.comandaIN];

        if (this.etapa == 6) return (this.produtoWait ? '': this.itemProduto.ProdutoNome);
        if (this.etapa == 7) return this.itemProduto.ProdutoNome;
        if (this.etapa == 8) return (comanda.Mesa ? 'Mesa ' + comanda.Mesa : 'Lançado');

    }

    bmaskerMask() {

        let size = (this.textdata || '').replace('.', '').length;
        let mask = (size <= 4 ? '0000' : (size == 5 ? '00.000' : '000.000.000-00'));
        return {mask: mask, type: 'num', len: mask.length};

    }

    comandaFind(force) {

        if (!this.util.validaCNPF(this.textdata) && !force) return;

        let onPush = (data) => {
            this.textdata = '';

            let array = this.rootComanda.Dividirs;
            let comanda = (data.Comandas || [])[0];

            if (!comanda) {
                this.util.alertSimply('Não encontrado');
                return;
            }

            if (comanda && comanda.PaybookBora) {
                this.util.alertSimply('Checkout Realizado');
                return;
            }

            if (comanda && comanda.PaybookFlag > TPaybookFlag.pfOpen) {
                this.util.alertSimply('Checkin Travado');
                return;
            }

            if (comanda) {
                let index = array.findIndex(CO => CO.ComandaID == comanda.ComandaID);
                if (index < 0) {
                    array.push({});
                    index = array.length-1;
                }
                this.util.populateObj(array[index], comanda);
            }

        };

        let rnrn = this.util.validaCNPF(this.textdata);
        let params = '&ComandaText=' + this.textdata +
                     '&ComandaMode=' + (rnrn ? TAcessoFind.afFindRnid : TAcessoFind.afFindNoro);

        let loading = this.util.loadingDots();
        loading.present();

        this.util.monitorDesk(this.monitorBool, 'DESK-Comanda', this.hotspotID, params, TAction.acFind)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onPush(data),
                erro => this.util.alertResult(erro));

    }

    comandaSeat(seat) {

        if (this.etapa == 7) {
            this.itemConsumo.ConsumoSeat = seat;
            this.util.impact();
        }

    }

    comandaHalz() {

        this.comandaHalf = true;

    }

    //ESCOLHA
    escolhaInit(escolha, escolhe) {

        if (!this.monitorAuth.clusterRoot.Escolhas) return;
        
        this.monitorAuth.clusterRoot.Escolhas.forEach(AA => {
            if (escolha == null) AA._full = false;

            AA.Escolhas.forEach(BB => {
                if (escolha == null) BB._selected = (this.itemConsumo.Escolhas.findIndex(OX => OX.EscolhaID == BB.EscolhaID) >= 0);
                if (escolha != null && escolha.EscolhaID == AA.EscolhaID && escolhe.EscolhaID != BB.EscolhaID) BB._selected = false;
            });
        });

        if (escolha != null) this.util.impact();

    }

    escolhaSave() {

        this.itemConsumo.Escolhas = [];

        if (!this.monitorAuth.clusterRoot.Escolhas) return;

        this.monitorAuth.clusterRoot.Escolhas.forEach(OB => {
            OB.Escolhas.forEach((OC, IN) => {

                if (OC._selected) {
                    let push = this.util.deepCopy(OC);
                    this.itemConsumo.Escolhas.push(push);
                }

            });
        });

    }

    escolhaLine(consumo) {

        let result = consumo.TXT;
        consumo.Escolhas.forEach(OB => result = result + (result == '' ? '' : ', ') + OB.EscolhaNome);
        return result;

    }

    escolhaList() {

        if (!this.monitorAuth.clusterRoot.Escolhas) return;
        
        let array = this.itemEscolha.split(',');
        return this.monitorAuth.clusterRoot.Escolhas.filter(OB => (array.findIndex(ID => (ID == OB.EscolhaID)) >= 0));

    }



    //ADITION
    aditionInit() {

        this.monitorAuth.clusterRoot.Clusters.forEach(CL => {
            CL.Produtos.forEach(PD => {
                if (PD.ProdutoSale == TProdutoSale.psAdd) {
                    PD._qtde = this.util.jsSum(this.itemConsumo.ADD, ['ProdutoQtde'], 'ProdutoID', [PD.ProdutoID]);
                }
            });
        });

    }

    aditionSave() {

        this.itemConsumo.ADD = [];

        this.monitorAuth.clusterRoot.Clusters.forEach(CL => {
            CL.Produtos.forEach(PD => {
                if (PD.ProdutoSale == TProdutoSale.psAdd && PD._qtde > 0) {
                    let push = this.util.deepCopy({ProdutoID: PD.ProdutoID, ProdutoNome: PD.ProdutoNome, ProdutoQtde: PD._qtde, PrecifyCash: PD.PrecifyCash});
                    this.itemConsumo.ADD.push(push);
                }
            });
        });

    }

    aditionList() {

        let array = [];

        this.monitorAuth.clusterRoot.Clusters.forEach(CL => {
            CL.Produtos.forEach(PD => {
                if (PD.ProdutoSale == TProdutoSale.psAdd) array.push(PD);
            });
        });

        return array;

    }

    aditionQtde(soma, adition, event?) {

        if (event) event.stopPropagation();

        if (adition._qtde == 0 && !soma) return;

        if (!adition._qtde) adition._qtde = 0;
        adition._qtde = adition._qtde + (soma ? 1 : -1);
        this.util.impact();

    }



    //CONSUMO
    consumoOpen(consumo) {

        let object = {etapa: 7, monitorBool: this.monitorBool, hotspotID: this.hotspotID, rootComanda: this.rootComanda, comandaIN: this.comandaIN, itemProduto: this.itemProduto, itemEscolha: this.itemEscolha, itemConsumo: consumo};
        this.util.modalopen(ConsumoSalePage, 'alto', false, object).subscribe();

    }

    consumoQtde(soma, start: boolean = false) {

        if (this.qtdeConsumo.length == 1 && !soma) return;
        if (this.qtdeConsumo.length >= 20 && soma) return;

        let seat = this.rootComanda.Comandas[this.comandaIN].Seat;
    
        if ( soma) this.qtdeConsumo.push({ConsumoSeat: seat, TXT: '', Escolhas: [], OBS: [], ADD: []});
        if (!soma) this.qtdeConsumo.splice(this.qtdeConsumo.length-1, 1);
        this.util.impact();

        if (start) {
            this.produtoWait = true;
            setTimeout(() => this.produtoWait = false, 1200);
        }

    }

    consumoSave() {

        //GAMBI - Corrigindo o Click do Usuario
        if (this.textdata) {
            this.comandaFind(true);
            return;
        }

        let comandaID = '';
        this.rootComanda.Dividirs.forEach(CM => comandaID = comandaID + (comandaID == '' ? '' : ';') + CM.ComandaID);

        let json = {Consumos: this.qtdeConsumo};

        let params =
            '&ComandaID=' + comandaID +
            '&ConsumoID=0' +
            '&ConsumoPedy=' + this.monitorAuth.clusterRoot.ConsumoPedy +
            '&ConsumoMesa=' + this.rootComanda.Comandas[this.comandaIN].Mesa +
            '&ConsumoSeat=' + this.rootComanda.Comandas[this.comandaIN].Seat +
            '&ConsumoMeio=' + this.meioConsumo +
            '&EstoqueID=0' + //this.monitorAuth.clusterRoot.EstoqueID +
            '&ProdutoID=' + this.itemProduto.ProdutoID +
            '&UnirID=0' +
            '&AdicionalID=0';

        let loading = this.util.loadingDots();
        loading.present();

        this.util.monitorDesk(this.monitorBool, 'DESK-Consumo', this.hotspotID, params, TAction.acSave, json)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.dismiss(),
                erro => this.util.alertResult(erro)
            );

    }

    dividirLixo(index) {

        //Comanda principal não pode excluir.
        if (index == 0) return;

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Remover', handler: () => this.rootComanda.Dividirs.splice(index, 1), role: 'destructive'});
        this.util.sheetOpen(buttons, 'ACTION', 0);

    }

    dismiss(force?) {

        //ESCOLHA + ADICIONAL + TAPTEXT
        if (this.etapa == 7 && force) {
            this.escolhaSave();
            this.aditionSave();
        }

        //Remove comanda adicionada para divisao na conta
        if (this.etapa == 6) {
            this.rootComanda.Dividirs = [];
        }

        this.viewCtrl.dismiss({});

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/consumo-sale/consumo-sale.ts